import { useEffect, useState } from "react";
import {
  FormControlLabel,
  Checkbox,
  CardContent,
  Grid,
  InputLabel,
  Select,
  MenuItem,
  FormControl,
  TextField,
  Card,
  Table,
  TableBody,
  TableCell,
  Container,
  TableContainer,
  TableRow,
  Button,
  TablePagination,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import Page from "./../../components/Page";
import Scrollbar from "./../../components/Scrollbar";
import { UserListHead } from "../../sections/@dashboard/user";
import HeaderBreadcrumbs from "./../../components/HeaderBreadcrumbs";
import Loader from "src/components/Loader";
import {
  GetPlayerAccumulatorListAction,
  MatchListAction,
  ResetMatchListAction,
  ResetPlayerAccumulatorListAction,
  ResetUpdatePlayerAction,
  SeriesListAction,
  UpdatePlayerAction,
} from "src/redux/actions/AccumulatorAction";
import moment from "moment";

export default function CricketPlayerAccumulator() {
  const dispatch = useDispatch();
  const playerAccSelector = useSelector(
    (state) => state.accumulator.player_acc_list.data
  );
  const seriesDropData = useSelector(
    (state) => state.accumulator.series_list.data
  );
  const MatchDropData = useSelector(
    (state) => state.accumulator.match_list.data
  );
  const PlayerUpdateAccSelector = useSelector(
    (state) => state.accumulator.player_acc_update
  );
  const loadingSelector = useSelector((state) => state.accumulator.loading);
  const [seriesID, setSeriesID] = useState();
  const [matchID, setMatchID] = useState();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [playerAccData, setPlayerAccData] = useState([]);
  const [count, setCount] = useState(0);
  const [playerNameString, setPlayerNameString] = useState("");

  useEffect(() => {
    dispatch(SeriesListAction("ckt"));
    return () => {
      dispatch(ResetUpdatePlayerAction());
      dispatch(ResetMatchListAction());
      dispatch(ResetPlayerAccumulatorListAction());
    };
  }, [dispatch]);

  useEffect(() => {
    if (matchID) {
      dispatch(
        GetPlayerAccumulatorListAction(page + 1, rowsPerPage, {
          match_id: matchID,
          type: "Cricket",
        })
      );
    }
  }, [page, rowsPerPage, matchID]);

  useEffect(() => {
    if (seriesID) {
      dispatch(
        MatchListAction({
          type: "Cricket",
          league_id: seriesID,
        })
      );
    }
  }, [seriesID]);

  useEffect(() => {
    let data = playerAccSelector?.data?.player_list;
    let arr = data?.map((object) => {
      return { ...object, selected: false };
    });
    setPlayerAccData(arr);
  }, [playerAccSelector]);

  const handleChangePage = (_, newPage) => {
    setPlayerAccData([]);
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setPlayerAccData([]);
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const setReset = () => {
    dispatch(
      GetPlayerAccumulatorListAction(page + 1, rowsPerPage, {
        match_id: matchID,
        type: "Cricket",
      })
    );
    setPlayerNameString("");
  };
// handleSelected Player
  const handleSelectedPlayer = (check, index, value) => {
    playerAccData[index].selected = check;
    setPlayerAccData(playerAccData);
    setCount(count + 1);
    let data = {
      type: "Cricket",
      pid: value.player_id,
      selectedBy: check,
      match_id: matchID,
      player_name: value.player_name,
    };
    dispatch(UpdatePlayerAction(data));
  };

  const handleNameFilter = (value) => {
    setPlayerNameString(value);
    if (value.length > 3) {
      dispatch(
        GetPlayerAccumulatorListAction(page + 1, rowsPerPage, {
          match_id: matchID,
          type: "Cricket",
          player_name: value,
        })
      );
    } else if (value.length == 0) {
      dispatch(
        GetPlayerAccumulatorListAction(page + 1, rowsPerPage, {
          match_id: matchID,
          type: "Cricket",
        })
      );
    }
  };

  useEffect(() => {
    if (Object.keys(PlayerUpdateAccSelector).length > 0) {
      if (PlayerUpdateAccSelector.data.status) {
        dispatch(ResetUpdatePlayerAction());
        dispatch(
          GetPlayerAccumulatorListAction(page + 1, rowsPerPage, {
            match_id: matchID,
            type: "Cricket",
          })
        );
      }
    }
  }, [PlayerUpdateAccSelector]);

  return (
    <Page title="Cricket || Player Accumulator">
      {loadingSelector ? <Loader /> : null}

      <Container maxWidth="lg">
        <HeaderBreadcrumbs
          heading="Cricket Player Accumulator"
          links={[
            { name: "Dashboard", href: "/dashboard/app" },
            { name: "Cricket Player Accumulator" },
          ]}
        />
        <Card>
          <CardContent>
            <Scrollbar>
              <TableContainer sx={{ minWidth: 800 }}>
                <Grid
                  container
                  spacing={2}
                  style={{ marginBottom: 30, marginTop: 2 }}
                >
                  <Grid item md={3}>
                    <FormControl fullWidth>
                      <InputLabel id="series-label"> Select Series </InputLabel>
                      <Select
                        labelId="series-label"
                        onChange={({ target }) => setSeriesID(target.value)}
                        id="series"
                        label="Select Series"
                      >
                        {seriesDropData &&
                          seriesDropData?.data?.active_series_list.map(
                            (value, index) => {
                              return (
                                <MenuItem value={value.cid} key={index}>
                                  {" "}
                                  {value.name}
                                </MenuItem>
                              );
                            }
                          )}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item md={3}>
                    <FormControl fullWidth>
                      <InputLabel id="series-label"> Select Match </InputLabel>
                      <Select
                        labelId="Match-label"
                        onChange={({ target }) => setMatchID(target.value)}
                        id="Match"
                        label="Select Match"
                      >
                        {MatchDropData &&
                          MatchDropData?.data?.match_list
                            ?.sort((a, b) =>
                              a.date_start_ist > b.date_start_ist ? 1 : -1
                            )
                            .map((value, index) => {
                              return (
                                <MenuItem value={value.match_id} key={index}>
                                  {" "}
                                  {value.title} (
                                  {value.date_start_ist
                                    ? moment(value.date_start_ist).format(
                                        "DD/MM/YYYY"
                                      )
                                    : "-"}
                                  )
                                </MenuItem>
                              );
                            })}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item md={3}>
                    <FormControl fullWidth>
                      <TextField
                        onChange={({ target }) =>
                          handleNameFilter(target.value)
                        }
                        type="text"
                        label="Player Name"
                        variant="outlined"
                        value={playerNameString}
                      />
                    </FormControl>
                  </Grid>
                  <Grid
                    item
                    md={3}
                    style={{
                      textAlign: "right",
                      marginTop: 15,
                      paddingRight: 15,
                    }}
                  >
                    <Button
                      size="small"
                      color="primary"
                      className="btn"
                      onClick={() => setReset()}
                    >
                      Reset Filter
                    </Button>
                  </Grid>
                </Grid>

                <Table>
                  <UserListHead
                    headLabel={[
                      { id: "c_no", label: "Sr no.", alignRight: false },
                      { id: "id", label: "Player ID", alignRight: false },
                      { id: "name", label: "Player Name", alignRight: false },
                      { id: "role", label: "Player Role", alignRight: false },
                      { id: "style", label: "Player Style", alignRight: false },
                      { id: "rating", label: "Rating", alignRight: false },
                      { id: "action", label: "Action", alignRight: false },
                    ]}
                  />
                  <TableBody>
                    {playerAccData &&
                      playerAccData
                        ?.sort((a, b) =>
                          a.player_name < b.player_name ? -1 : 1
                        )
                        .map((value, index) => {
                          return (
                            <TableRow hover key={index}>
                              <TableCell component="th" scope="row">
                                {page * rowsPerPage + (index + 1)}.
                              </TableCell>
                              <TableCell component="th" scope="row">
                                {value?.player_id ? value.player_id : "-"}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                {value?.player_name ? value.player_name : "-"}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                {value?.playing_role === "wk"
                                  ? "Wicket-Keeper"
                                  : value?.playing_role === "bat"
                                  ? "Batsman"
                                  : value?.playing_role === "all"
                                  ? "All Rounder"
                                  : value?.playing_role === "bowl"
                                  ? "Bowler"
                                  : "-"}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                {value.playing_role === "bowl"
                                  ? value.bowling_style
                                    ? value.bowling_style
                                    : "-"
                                  : value.batting_style
                                  ? value.batting_style
                                  : "-"}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                {value.rating ? value.rating : "-"}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={
                                        value.selectedBy
                                          ? value.selectedBy
                                          : false
                                      }
                                      onChange={({ target }) =>
                                        handleSelectedPlayer(
                                          target.checked,
                                          index,
                                          value
                                        )
                                      }
                                    />
                                  }
                                />
                              </TableCell>
                            </TableRow>
                          );
                        })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Scrollbar>

            <TablePagination
              rowsPerPageOptions={[25, 50, 100, 150, 200]}
              component="div"
              count={playerAccSelector ? playerAccSelector.data.total_count : 0}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </CardContent>
        </Card>
      </Container>
    </Page>
  );
}
